import { useEffect, useState } from 'react';
import { tickerNews } from '@/mocks/gossip';

const navLinks = [
  { label: '今日热榜', href: '#hot' },
  { label: '五大栏目', href: '#topics' },
  { label: '最新瓜田', href: '#feed' },
  { label: '人物与幕后', href: '#network' },
  { label: '深度阅读', href: '#deep' },
  { label: '关于与投稿', href: '#about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      {/* red news ticker */}
      <div className="relative z-10 flex items-center overflow-hidden bg-primary-600 text-background-50">
        <div className="z-10 flex items-center gap-2 shrink-0 bg-primary-600 px-3 md:px-5 py-1.5">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-300 animate-pulse-dot"></span>
          <span className="text-[11px] md:text-xs font-bold tracking-widest whitespace-nowrap">热点速递</span>
        </div>
        <div className="ticker-mask relative flex-1 overflow-hidden py-1.5">
          <div className="animate-ticker flex w-max items-center gap-12 pr-12">
            {[...tickerNews, ...tickerNews].map((n, i) => (
              <span key={i} className="flex items-center gap-3 whitespace-nowrap text-xs md:text-[13px]">
                <span className="opacity-40">◆</span>
                <span>{n}</span>
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* main nav */}
      <div
        className={`transition-colors duration-300 ${
          solid ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
        }`}
      >
        <nav className="mx-auto flex max-w-[1320px] items-center justify-between px-4 md:px-6 h-[60px]">
          <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-brand text-lg text-background-50">
              瓜
            </span>
            <span
              className={`font-heading text-lg md:text-xl font-bold tracking-wide ${
                solid ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              吃瓜热点
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className={`px-3.5 py-2 rounded-md text-sm transition-colors hover:bg-primary-100/70 whitespace-nowrap ${
                  solid ? 'text-foreground-700 hover:text-primary-700' : 'text-background-50/95 hover:bg-white/10'
                }`}
              >
                {l.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <a
              href="#hot"
              className="hidden md:inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line text-base"></i>
              开始吃瓜
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className={`lg:hidden flex h-10 w-10 items-center justify-center rounded-md transition-colors ${
                solid ? 'text-foreground-800 hover:bg-background-200' : 'text-background-50 hover:bg-white/10'
              }`}
            >
              <i className={`text-2xl ${open ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
            </button>
          </div>
        </nav>

        {/* mobile panel */}
        {open ? (
          <div className="lg:hidden border-t border-background-200 bg-background-50/95 backdrop-blur px-4 py-4">
            <div className="flex flex-col gap-1">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-primary-100/70 hover:text-primary-700"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#hot"
                onClick={() => setOpen(false)}
                className="mt-2 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap"
              >
                <i className="ri-fire-line"></i>
                开始吃瓜
              </a>
            </div>
          </div>
        ) : null}
      </div>
    </header>
  );
}